<template>
  <w-icon-wrapper icon-name='work-table-layout-icon'>
    <path
      id='_44_Tabellen_Layout_Icon'
      d='M0,0V24H24V0ZM22,2V7H2V2ZM15,9V22H9V9ZM2,9H7V22H2ZM17,22V9h5V22Z'
      data-name='44 Tabellen Layout_Icon'
      fill='currentColor'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconTableLayout' };
</script>
